import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-result-found',
  standalone: true,
  imports: [NgClass],
  templateUrl: './no-result-found.component.html',
  styleUrl: './no-result-found.component.scss',
})
export class NoResultFoundComponent {
  @Input() heading: string = '';
  @Input() backgroundUrl: string = '';
}
